<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxPosition">Position</label>
                    <input id="txbxPosition" type="text" class="form-control" [(ngModel)]="target.position" name="position" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="txbxName">Name</label>
                    <input id="txbxName" type="text" class="form-control" [(ngModel)]="target.name" name="name" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="offerDate">Offer Date</label>
                    <wj-input-date id="offerDate" [(ngModel)]="target.offerDate" name="offerDate"></wj-input-date>
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="startDate">Expected Start Date</label>
                    <wj-input-date id="startDate" [(ngModel)]="target.startDate" name="startDate"></wj-input-date>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
